import { useDeferredThirdParty } from "@hooks/useDeferredThirdParty";
import { useRouter } from "next/router";
import Script from "next/script";

const GoftinoWidget = () => {
  const { pathname } = useRouter();
  const shouldLoad = useDeferredThirdParty(2_500);
  const widgetId = "KUN6aK";
  const scriptUrl = `https://www.goftino.com/widget/${widgetId}`;
  const isEmbedRoute = pathname?.startsWith?.("/embed");

  if (!shouldLoad || isEmbedRoute) return null;

  return (
    <Script
      id="goftino-widget"
      strategy="lazyOnload"
      dangerouslySetInnerHTML={{
        __html: `
            (function(){
              var i="${widgetId}";
              var d=document;
              var g=d.createElement("script");
              var s="${scriptUrl}";
              var l=localStorage.getItem("goftino_"+i);
              g.type="text/javascript";
              g.async=true;
              g.src=l ? s + "?o=" + l : s;
              d.head.appendChild(g);
            })();
          `,
      }}
    />
  );
};

export default GoftinoWidget;
